function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "tw",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m74.268 158.688 142.479.023.759 179.45-72.04-.504-.021-107.674-71.245-.112.068-71.183Z",
    style: {
      strokeWidth: 0,
      stroke: "#fff",
      strokeMiterlimit: 1,
      paintOrder: "stroke",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.59,
    cy: 192.178,
    r: 35.956,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.41 158.808 83.007.088-75.185 177.96-82.128-.177 73.733-177.728z",
    style: {
      stroke: "#000",
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwLogo2);
export default __webpack_public_path__ + "static/media/tw-logo2.7e3de5297478c8fb22f68f7d904d4d92.svg";
export { ForwardRef as ReactComponent };